import { NgModule } from '@angular/core';

import { ButtonFieldModule } from 'common/dynamic-form/types/button/button.module';
import { CaptchaFieldModule } from 'common/dynamic-form/types/captcha/captcha.module';
import { CheckboxFieldModule } from 'common/dynamic-form/types/checkbox/checkbox.module';
import { GroupFieldModule } from 'common/dynamic-form/types/group/group.module';
import { HiddenFieldModule } from 'common/dynamic-form/types/hidden/hidden.module';
import { InputFieldModule } from 'common/dynamic-form/types/input/input.module';
import { LinkFieldModule } from 'common/dynamic-form/types/link/link.module';
import { OTPFieldModule } from 'common/dynamic-form/types/otp/otp.module';
import { PasswordFieldModule } from 'common/dynamic-form/types/password/password.module';
import { PhoneModule } from 'common/dynamic-form/types/phone/phone.module';
import { SelectFieldModule } from 'common/dynamic-form/types/select/select.module';
import { SkeletonFieldModule } from 'common/dynamic-form/types/skeleton/skeleton.module';
import { SwitcherFieldModule } from 'common/dynamic-form/types/switcher/switcher.module';
import { TemplateFieldModule } from 'common/dynamic-form/types/template/template.module';
import { TextDataFieldModule } from 'common/dynamic-form/types/textdata/textdata.module';
import { FieldBaseModule } from 'common/dynamic-form/wrappers/field-base/field-base.module';
import { PageWrapperModule } from 'common/dynamic-form/wrappers/page/page.module';
import { ValidationErrorModule } from 'common/dynamic-form/wrappers/validation-error/validation-error.module';

import { DynamicFormModule } from './dynamic-form.module';
import { GeneralErrorFieldModule } from './types/general-error/general-error.module';
import { ExtformLayoutModule } from './types/layout/extform/extform-layout.module';

const structuralFields = [ExtformLayoutModule, GroupFieldModule];

const visualFields = [
  TemplateFieldModule,
  LinkFieldModule,
  ButtonFieldModule,
  TextDataFieldModule,
  SkeletonFieldModule,
  GeneralErrorFieldModule,
];

const modelFields = [
  InputFieldModule,
  SelectFieldModule,
  PhoneModule,
  CheckboxFieldModule,
  HiddenFieldModule,
  OTPFieldModule,
  PasswordFieldModule,
  CaptchaFieldModule,
  SwitcherFieldModule,
  GeneralErrorFieldModule,
];

const wrappers = [FieldBaseModule, PageWrapperModule, ValidationErrorModule];

export const DYNAMIC_FORM_LOGIN_MODULES = [
  ...structuralFields,
  ...visualFields,
  ...modelFields,
  ...wrappers,
];

@NgModule({
  exports: [
    ...structuralFields,
    ...visualFields,
    ...modelFields,
    ...wrappers,
    DynamicFormModule,
  ],
})
export class DynamicFormLoginModule {}
